const PROMO_VIEWED_SESSION_KEY = 'promo_progress_viewed_cards';

export const isPromoViewedInSession = (promoId: string): boolean => {
    try {
        const viewed: string[] = JSON.parse(sessionStorage.getItem(PROMO_VIEWED_SESSION_KEY) || '[]');
        return viewed.includes(promoId);
    } catch {
        return false;
    }
};

export const markPromoViewedInSession = (promoId: string): void => {
    try {
        const viewed: string[] = JSON.parse(sessionStorage.getItem(PROMO_VIEWED_SESSION_KEY) || '[]');
        if (!viewed.includes(promoId)) {
            viewed.push(promoId);
            sessionStorage.setItem(PROMO_VIEWED_SESSION_KEY, JSON.stringify(viewed));
        }
    } catch {
        /* no-op */
    }
};

export const clearPromoProgressViewedSession = (): void => {
    try {
        sessionStorage.removeItem(PROMO_VIEWED_SESSION_KEY);
    } catch {
        /* no-op */
    }
};
